/**
 * A tiny lift shaft: where the car is among the floors it serves. It places
 * a car only at the floor its own row names, and draws none when the reading
 * does not vouch for one, the rule every other lift drawing keeps
 * (`LiftLook`).
 */
export type ShaftTone = 'normal' | 'robot' | 'trouble';

const TONE_COLOR: Readonly<Record<ShaftTone, string>> = {
  normal: 'var(--nx-muted)',
  robot: 'var(--nx-blue)',
  trouble: 'var(--nx-error)',
};

const WIDTH = 8;
const HEIGHT = 24;
const CAR_HEIGHT = 6;

export function ShaftGlyph({
  levels,
  level,
  tone,
}: {
  levels: readonly string[];
  level: string | null;
  tone: ShaftTone;
}) {
  const index = level === null ? -1 : levels.indexOf(level);
  // `levels` runs bottom to top, so the first floor sits at the foot.
  const carY =
    index < 0 || levels.length < 2
      ? null
      : (1 - index / (levels.length - 1)) * (HEIGHT - CAR_HEIGHT);
  return (
    <svg
      className="nx-shaft-glyph"
      width={WIDTH}
      height={HEIGHT}
      viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
      aria-hidden="true"
    >
      <rect
        x="0.5"
        y="0.5"
        width={WIDTH - 1}
        height={HEIGHT - 1}
        rx="1.5"
        fill="none"
        stroke="var(--nx-border)"
      />
      {carY !== null && (
        <rect x="1" y={carY} width={WIDTH - 2} height={CAR_HEIGHT} rx="1" fill={TONE_COLOR[tone]} />
      )}
    </svg>
  );
}
